/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Icsrm_Hda8Inputs */

const en_cv_extract_form_enum_icsrm_hda8 = /** @type {(inputs: Cv_Extract_Form_Enum_Icsrm_Hda8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmstadt University of Applied Sciences`)
};

const de_cv_extract_form_enum_icsrm_hda8 = /** @type {(inputs: Cv_Extract_Form_Enum_Icsrm_Hda8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochschule Darmstadt`)
};

/**
* | output |
* | --- |
* | "Darmstadt University of Applied Sciences" |
*
* @param {Cv_Extract_Form_Enum_Icsrm_Hda8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_icsrm_hda8 = /** @type {((inputs?: Cv_Extract_Form_Enum_Icsrm_Hda8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Icsrm_Hda8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_icsrm_hda8(inputs)
	return en_cv_extract_form_enum_icsrm_hda8(inputs)
});
export { cv_extract_form_enum_icsrm_hda8 as "cv_extract_form_enum_ICSRM_HDA" }